import { render, staticRenderFns } from "./chicang.vue?vue&type=template&id=28fd6d91&scoped=true&"
import script from "./chicang.vue?vue&type=script&lang=js&"
export * from "./chicang.vue?vue&type=script&lang=js&"
import style0 from "./chicang.vue?vue&type=style&index=0&id=28fd6d91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd6d91",
  null
  
)

export default component.exports